import { Check, Trash2 } from 'lucide-react'
import { renderToString } from 'react-dom/server'

import { CustomMenuItem } from '@fortem-monorepo/react-ag'
import { createContextMenu } from '@fortem-monorepo/react-ag'
import { Account, Audit, Trades } from '@fortem-monorepo/web-sdk'

import { useApproveElementMutation } from '@/react-query/mutations/audit'
import { useDeleteOldDBTradeMutation } from '@/react-query/mutations/trades'

export const createOlddbContextMenu = ({
  internalUser,
  withConfirmation,
  approveMutation,
  deleteMutation,
}: {
  internalUser: Account.InternalUser | null
  withConfirmation?: (cb: () => Promise<any>) => void
  approveMutation: ReturnType<typeof useApproveElementMutation>
  deleteMutation: ReturnType<typeof useDeleteOldDBTradeMutation>
}) => {
  return createContextMenu<Trades.OlddbTrade>((params) => {
    const blotterid = params?.node?.data?.blotterid?.toString()!
    const productname = params.node?.data?.productname
    const status = params.node?.data?.status
    const canBeDeleted = !!blotterid && !!productname

    const statusIsNotApproved = status !== Audit.STATUSES.APPROVED
    const lastUpdatedByUser = internalUser?.user_id == params.node?.data?.submitted_by

    const canApprove = statusIsNotApproved && !lastUpdatedByUser

    const withExtraActions = canApprove || canBeDeleted

    return [
      ...(canBeDeleted
        ? [
            {
              name: `Delete Trade ${params.node?.data?.blotterid}`,
              icon: renderToString(<Trash2 size={16} />),
              cssClasses: ['hover:bg-red-100/50!', 'text-red-600!', 'font-medium!'],
              action: () =>
                withConfirmation?.(async () =>
                  deleteMutation.mutateAsync({
                    blotterid,
                    productname,
                  }),
                ),
            },
          ]
        : []),
      ...(canApprove
        ? ([
            {
              name: 'Approve Trade',
              icon: renderToString(<Check size={16} />),
              cssClasses: ['hover:bg-green-100!', 'text-green-600!'],
              action: () => {
                return approveMutation.mutateAsync({
                  element_id: blotterid,
                  element_type: Audit.ELEMENT_TYPES.OLD_TRADE,
                })
              },
            },
          ] satisfies CustomMenuItem[])
        : []),
      ...(withExtraActions ? (['separator'] satisfies CustomMenuItem[]) : []),
      'copy',
      'copyWithGroupHeaders',
      'copyWithHeaders',
      'separator',
      'export',
    ]
  })
}
